




























































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import DropArea from "../../components/DropArea.vue";
import { BModal } from 'bootstrap-vue';
import { SheetBase, Examinee, Curriculum, Condition, Sheet, Student, User, SheetGroup } from "../../modules/teacher/DigitalPaperSheetEdit"

export interface Data {
  sheet_group_key: string
  tabNo: number
  sheetBase: SheetBase
  examinees: Examinee[]
  curriculums: Curriculum[]
  errors: string[]
  isNew: boolean
  isEditable: boolean
  isExistsUploaded: boolean
  copySheets: Sheet[]
  copyTargetSheet: Sheet
  condition: Condition
  totalCount: number
  users: User[]
  modalUsers: User[]
  user_condition: any
  isAllCheckedUser: boolean
  students: Student[]
  isUploaded: boolean
  sheetGroups: SheetGroup[]
  selectedSheetGroupIdx: number
  isAllCheckedStudent: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context){

    const modalCopySheetRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_group_key: "",
      tabNo: 1,
      sheetBase: new SheetBase(),
      examinees: new Array<Examinee>(),
      curriculums: new Array<Curriculum>(),
      errors: new Array<string>(),
      isNew: false,
      isEditable: false,
      isExistsUploaded: false,
      copySheets: [],
      copyTargetSheet: null,
      condition: new Condition(),
      totalCount: 0,
      users: [],
      modalUsers: [],
      user_condition: {
        name: "",
        role: "",
      },
      isAllCheckedUser: false,
      students: [],
      isUploaded: false,
      sheetGroups: [],
      selectedSheetGroupIdx: 0,
      isAllCheckedStudent: false,
    });

    /******************************
     * 試験検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 試験検索
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/sheet_edit/search_sheet?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.copySheets = response.data.sheets.map((x: any) => new Sheet(x));
        state.copyTargetSheet = null;
        state.totalCount = response.data.sheets.length > 0 ? response.data.sheets[0].at_full_count : 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * コピー対象試験選択
     ******************************/

    const setCopyTargetSheet = (sheet: any) => {
      state.copyTargetSheet = sheet;
      state.sheetBase.name = sheet.name;
      state.sheetBase.curriculum_id = sheet.curriculum_id;
      state.sheetBase.subject_name = sheet.subject_name;
      state.sheetBase.grade = sheet.grade;
      state.sheetBase.browse_lock = sheet.browse_lock;
      state.sheetBase.edit_lock = sheet.edit_lock;
      state.sheetBase.is_sort_answer_image_enable = sheet.is_sort_answer_image_enable;
      state.sheetBase.is_print_view_point = sheet.is_print_view_point;
      state.sheetBase.is_print_part1 = sheet.is_print_part1;
      state.sheetBase.digital_answer_type = sheet.digital_answer_type;
      state.sheetBase.is_self_scoring_enable = sheet.is_self_scoring_enable;
      state.sheetBase.is_disp_correct_question_image = sheet.is_disp_correct_question_image;
      state.sheetBase.subject_code = sheet.subject_code;
      
      modalCopySheetRef.value.hide();
    }

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      const pageCache = state.condition.page;
      state.condition = new Condition();
      state.condition.page = pageCache;
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * 生徒のデジタルペーパー一覧画面へ
     ******************************/

    const toDigitalPaperSheetList = (email: string) => {
      context.root.$store.commit("setDigitalPaperEmail", email);
      context.root.$router.push("/digital_paper_site/sheet_list").catch(err => {});
    }

    /******************************
     * 生徒成績サイトのデジタルペーパー一覧画面へ
     ******************************/

    const toDigitalPaperSheetListStudentManage = (student_no_character: string) => {
      context.root.$store.commit("setStudentNoCharacter", student_no_character);
      context.root.$router.push(`/teacher_site/digital_paper_list`).catch(err => {});
    }

    /******************************
     * 名簿テンプレートダウンロード
     ******************************/

    const downloadMeiboTemplate = async () => {

      await http.post(`/api/teacher/digital_paper_sheet_edit/download_meibo_template/${state.sheet_group_key}`, {examinees: state.examinees}, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `meibo_digital_paper_template.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /******************************
     * 名簿アップロードAPI
     ******************************/

    const uploadMeibo = async (file: any) => {
      let fd = new FormData();
      fd.append('upload[file]', file);
      fd.append('is_student_manage_active', context.root.$store.getters.isOptionStudentManageActive)

      if(!window.confirm("受験者情報を読み込みます。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/digital_paper_sheet_edit/upload_meibo`, fd).then(response => {
        const examinees = new Array<Examinee>();
        response.data.examinees.forEach((examinee: any) => {
          examinees.push(new Examinee(examinee));
        });
        state.examinees = examinees
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 登録前のデータチェック
     ******************************/

    const validate = () => {
      state.errors = new Array<string>();

      if (!state.sheetBase.exec_date) {
        state.errors.push("実施日が入力されていません。");
      }
      if (!state.sheetBase.name) {
        state.errors.push("試験名が入力されていません。");
      }
      if(!context.root.$store.getters.isOptionSchoolSubjectActive && !state.sheetBase.curriculum_id){
        state.errors.push("教科が選択されていません。");
      }
      if (!state.sheetBase.grade) {
        state.errors.push("学年が選択されていません。");
      }
      if (!state.sheetBase.digital_answer_type) {
        state.errors.push("解答方式が選択されていません。");
      }

      if(state.sheetBase.is_linked_students){
        // 生徒管理で名簿同期する場合
        if(state.sheetGroups.filter(x => x.student_no_characters.length > 0).length == 0){
          state.errors.push(`受験者が0名です。`);
        }

        // 成績管理OFF=>DP専用サイトからログイン=>email必須のため
        // 受験者の生徒マスタにemailが登録されているかチェック
        if(!context.root.$store.getters.isOptionStudentManageActive){
          const examinees = convertStudentToExaminee();
          if(examinees.filter(x => !x.email).length > 0){
            state.errors.push(`受験者の生徒マスタにメールアドレスが登録されていません。生徒の解答用サイトログイン用にGoogleアカウントのメールアドレスの登録が必要です。`);
          }
        }
      }else{
        // エクセル名簿で登録する場合
        if (state.examinees.length == 0) {
          state.errors.push("受験者情報エクセルが読み込まれていません。");
        }
      }

      return state.errors.length == 0;
    };

    /******************************
     * 新規登録API
     ******************************/

    const createClick = async () => {
      if (!validate() || !window.confirm('試験を追加しますか？')) {
        return;
      }

      const param: any = {
        sheet_base: state.sheetBase,
        examinees: state.sheetBase.is_linked_students ? convertStudentToExaminee() : state.examinees,
        copy_target_sheet_group_key: state.copyTargetSheet ? state.copyTargetSheet.sheet_group_key : null,
        scorable_login_ids: scorable_login_ids.value
      };

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/digital_paper_sheet_edit`, param).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 更新API
     ******************************/

    const updateClick = async () => {

      if (!validate() || !window.confirm('試験を更新しますか？')) {
        return;
      }

      const param = {
        sheet_base: state.sheetBase,
        examinees: state.sheetBase.is_linked_students ? convertStudentToExaminee() : state.examinees,
        scorable_login_ids: scorable_login_ids.value
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/digital_paper_sheet_edit/update/${state.sheet_group_key}`, param).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 削除API
     ******************************/

    const deleteClick = async () => {
      
      context.root.$bvModal.hide('modal-confirm')

      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/digital_paper_sheet_edit/${state.sheet_group_key}`).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      state.isNew = context.root.$route.path.indexOf("new") != -1;
      
      if(!state.isNew){
        await http.get(`/api/teacher/digital_paper_sheet_edit/?sheet_group_key=${state.sheet_group_key}`).then(response => {
          state.sheetBase.grade = response.data.sheets[0].grade;
          state.sheetBase.name = response.data.sheets[0].name;
          state.sheetBase.curriculum_id = response.data.sheets[0].curriculum_id;
          state.sheetBase.subject_name = response.data.sheets[0].subject_name;
          state.sheetBase.exec_date = moment(response.data.sheets[0].exec_date).format('YYYY-MM-DD');
          state.sheetBase.created_by = response.data.sheets[0].created_by;
          state.sheetBase.browse_lock = response.data.sheets[0].browse_lock;
          state.sheetBase.edit_lock = response.data.sheets[0].edit_lock;
          state.sheetBase.is_sort_answer_image_enable = response.data.sheets[0].is_sort_answer_image_enable;
          state.sheetBase.is_print_view_point = response.data.sheets[0].is_print_view_point;
          state.sheetBase.is_print_part1 = response.data.sheets[0].is_print_part1;
          state.sheetBase.digital_answer_type = response.data.sheets[0].digital_answer_type;
          state.sheetBase.is_self_scoring_enable = response.data.sheets[0].is_self_scoring_enable;
          state.sheetBase.is_linked_students = response.data.sheets[0].is_linked_students;
          state.sheetBase.is_disp_correct_question_image = response.data.sheets[0].is_disp_correct_question_image;
          state.sheetBase.subject_code = response.data.sheets[0].subject_code;

          state.isUploaded = response.data.is_uploaded
          state.students = response.data.students.map((x: any) => new Student(x));
          state.examinees = response.data.examinees.map((x: any) => new Examinee(x));
          state.curriculums = response.data.curriculums.map((x: any) => new Curriculum(x));
          state.isEditable = state.sheetBase.created_by == null || state.sheetBase.created_by == context.root.$store.state.currentUser.login_id || context.root.$store.state.currentUser.role != Common.RoleEnum.Teacher2;

          state.curriculums = response.data.curriculums;
          state.users = response.data.users.map((x: any) => new User(x));
          const scorable_login_ids = response.data.scorable_login_ids;

          context.root.$nextTick(() => {
            state.modalUsers.filter(x => scorable_login_ids.includes(x.login_id)).forEach(x => x.is_selected = true);

            const sheetGroups: SheetGroup[] = [];
            grade_room_names.value.forEach(room_name => {
              const sheet = response.data.sheets.find((x: any) => x.room_name === room_name) || null;
              if(sheet){
                const students = state.students.filter(x => x.grade == state.sheetBase.grade && x.room_name == sheet.room_name).sort((a, b) => a.student_no - b.student_no);
                const student_no_characters = students.filter(x => x.is_selected).map(x => x.student_no_character);
                
                var sheetGroup = {
                  sheet_id: sheet.id,
                  room_name: room_name,
                  student_count: sheet.student_count,
                  is_uploaded: sheet.sheet_activities_count > 0,
                  students: students,
                  student_no_characters: student_no_characters,
                };
                sheetGroups.push(sheetGroup);
              }else{
                // 受験者0名のクラスの場合
                const sheetGroup = createEmptySheetGroup();
                sheetGroup.room_name = room_name;
                sheetGroup.students = state.students.filter(x => x.grade == state.sheetBase.grade && x.room_name == room_name).sort((a, b) => a.student_no - b.student_no);
                sheetGroup.student_no_characters = [];
                sheetGroup.student_count = sheetGroup.student_no_characters.length.toString();
                sheetGroups.push(sheetGroup);
              }
            });
            state.sheetGroups = sheetGroups;
          });
        })
        .catch(error=>{
          // 後続処理不能のため一覧に戻る
          if(error.response.status == 422){
            alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
          }else{
            alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
          }
          window.history.back();
        });
      }else{
        await http.get(`/api/teacher/digital_paper_sheet_edit/new`).then(response => {
          state.curriculums = response.data.curriculums.map((x: any) => new Curriculum(x));
          state.users = response.data.users.map((x: any) => new User(x));
          state.students = response.data.students.map((x: any) => new Student(x));
          state.sheetBase.is_linked_students = false;
          state.sheetBase.browse_lock = !context.root.$store.getters.isAdminOrTeacher1 && context.root.$store.getters.isOptionSheetViewCreateUserOnlyActive;
          searchUser();
        });
        state.isEditable = true;
      }
      context.root.$store.dispatch("hideOverlay");
    });

    /************************************************************
     * 教科・科目の変更監視
     ************************************************************/

    watch(() => [state.sheetBase.curriculum_id, state.sheetBase.subject_code], async (newVal: any, oldVal) => {

      state.users.forEach(x => x.is_selected = false);

      let modalUsers = state.users.map(x => x);

      if(state.sheetBase.curriculum_id){
        modalUsers = modalUsers.filter(x => x.role == "teacher1" || x.curriculum_id.includes(state.sheetBase.curriculum_id as any));
      }

      if(context.root.$store.getters.isOptionSchoolSubjectActive && state.sheetBase.subject_code){
        modalUsers = modalUsers.filter(x => x.role == "teacher1" || x.subject_codes.includes(state.sheetBase.subject_code));
      }

      state.modalUsers = modalUsers.sort((a, b) => {
        if (a.role === b.role) {
          return a.name.localeCompare(b.name);
        }
        return a.role.localeCompare(b.role);
      });
    });

    /************************************************************
     * ユーザモーダルの全件選択チェックボックず変更監視
     ************************************************************/
    
    watch(() => state.isAllCheckedUser, async (newVal, oldVal) => {
      state.modalUsers.forEach(x => x.is_selected = newVal);
    });

    /************************************************************
     * ユーザモーダルのユーザ検索
     ************************************************************/

     const searchUser = () => {
      let modalUsers = state.users.map(x => x);

      if(state.sheetBase.curriculum_id){
        modalUsers = modalUsers.filter(x => x.role == "teacher1" || x.curriculum_id.includes(state.sheetBase.curriculum_id as any));
      }

      if(context.root.$store.getters.isOptionSchoolSubjectActive && state.sheetBase.subject_code){
        modalUsers = modalUsers.filter(x => x.role == "teacher1" || x.subject_codes.includes(state.sheetBase.subject_code));
      }

      if(state.user_condition.name){
        modalUsers = modalUsers.filter(x => x.name.includes(state.user_condition.name));
      }

      if(state.user_condition.role){
        modalUsers = modalUsers.filter(x => x.role == state.user_condition.role);
      }

      state.modalUsers = modalUsers.sort((a, b) => {
        if (a.role === b.role) {
          return a.name.localeCompare(b.name);
        }
        return a.role.localeCompare(b.role);
      });
    }

    /************************************************************
     * ユーザモーダルの検索条件クリア
     ************************************************************/

    const clearUserCondition = () => {
      state.user_condition = {name: "", role: ""};
    }

    /************************************************************
     * 選択ユーザのログインID
     ************************************************************/

    const scorable_login_ids = computed((): string[] => {
      return state.modalUsers.filter(x => x.is_selected).map(x => x.login_id);
    });

    /************************************************************
     * 選択中の学年に設定されているクラス一覧
     * 生徒マスタリストから取得
     ************************************************************/

    const grade_room_names = computed(() => {
      
      if(state.sheetBase && state.sheetBase.grade){
        return Array.from(
          new Set(state.students.filter(student => student.grade === state.sheetBase.grade).map(student => student.room_name))
        ).sort((a: string, b: string) => Common.strCmpLogicalW(a, b));
      }else{
        return [];
      }
    });

    /************************************************************
     * 学年プルダウン変更監視
     ************************************************************/

    watch(() => state.sheetBase.grade, async () => {
      if(!state.sheetBase.is_linked_students){
        return;
      }

      state.sheetGroups = [];
      grade_room_names.value.forEach(room_name => {
        const sheetGroup = createEmptySheetGroup();
        sheetGroup.room_name = room_name;
        sheetGroup.students = state.students.filter(x => x.grade == state.sheetBase.grade && x.room_name == room_name).sort((a, b) => a.student_no - b.student_no);
        sheetGroup.student_no_characters = [];
        sheetGroup.student_count = "0";
        state.sheetGroups.push(sheetGroup);
      })
    });

    /************************************************************
     * 生徒名簿連携チェックボック変更監視
     ************************************************************/

    watch(() => state.sheetBase.is_linked_students, async (newVal) => {

      if(newVal){
        state.sheetGroups = [];
        grade_room_names.value.forEach(room_name => {
          const sheetGroup = createEmptySheetGroup();
          sheetGroup.room_name = room_name;
          sheetGroup.students = state.students.filter(x => x.grade == state.sheetBase.grade && x.room_name == room_name).sort((a, b) => a.student_no - b.student_no);
          sheetGroup.student_count = "0";
          sheetGroup.student_no_characters = [];
          state.sheetGroups.push(sheetGroup);
        })
      }else{
        state.sheetGroups = [];
        state.examinees = [];
      }
    });

    /************************************************************
     * 名簿同期の空のクラス情報作成
     ************************************************************/

    const createEmptySheetGroup = () => {
      const info: SheetGroup = {
        room_name: "",
        student_count: "",
        is_uploaded: false,
        student_no_characters: [],
        students: [],
      };
      return info;
    }

    /************************************************************
     * 名簿同期で選択中のクラス
     ************************************************************/

    const selectedSheetGroup = computed((): SheetGroup => {
      if(state.sheetGroups.length > 0 && state.selectedSheetGroupIdx != null){
        return state.sheetGroups[state.selectedSheetGroupIdx];
      }else{
        return null;
      }
    });

    /************************************************************
     * 生徒モーダルの全件選択チェックボックス変更監視
     ************************************************************/
    
    watch(() => state.isAllCheckedStudent, async (newVal) => {
      if(newVal){
        selectedSheetGroup.value.student_no_characters = selectedSheetGroup.value.students.map(x => x.student_no_character);
      }else{
        selectedSheetGroup.value.student_no_characters = [];
      }
    });

    /************************************************************
     * 名簿同期のstudentsから受験者のexamineesを生成
     ************************************************************/

    const convertStudentToExaminee = () => {
      let examinees: Examinee[] = [];
      state.sheetGroups.forEach(sheetGroup => {
        const students = sheetGroup.students.filter(student => sheetGroup.student_no_characters.includes(student.student_no_character));
        students.forEach(student => {
          let examinee = new Examinee({});
          examinee.room_name = sheetGroup.room_name;
          examinee.student_no = student.student_no;
          examinee.student_no_character = student.student_no_character;
          examinee.student_name = student.student_name;
          if(!context.root.$store.getters.isOptionStudentManageActive){
            examinee.email = student.email;
          }
          examinees.push(examinee);
        });
      });
      return examinees;
    }

    return {
      ...toRefs(state),
      createClick,
      updateClick,
      deleteClick,
      uploadMeibo,
      downloadMeiboTemplate,
      toDigitalPaperSheetList,
      toDigitalPaperSheetListStudentManage,
      modalCopySheetRef,
      searchClick,
      clearCondition,
      convertExecDate,
      changePage,
      setCopyTargetSheet,
      searchUser,
      clearUserCondition,
      grade_room_names,
      selectedSheetGroup,
    };
  }
})
